import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Japanese My Number generator following Single Responsibility Principle
 */
export class JpGenerator extends BaseGenerator {
  generate() {
    // Generate first 11 digits
    const digits = this.randomDigits(11);
    
    // Calculate check digit
    const weights = [6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < 11; i++) {
      sum += parseInt(digits[i]) * weights[i];
    }

    const remainder = sum % 11;
    const checkDigit = remainder <= 1 ? 0 : 11 - remainder;

    return digits + checkDigit;
  }
}